import { LoadingScreen } from '@drisk-ai/ui';
import { useLayoutEffect, useRef, useState } from 'react';

export function GoogleSdkProvider({ children }: { children: React.ReactNode }) {
  const isInitialized = useRef(false);
  const [loading, setLoading] = useState(!window?.google);

  useLayoutEffect(() => {
    const loadSdk = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (typeof window !== 'undefined' && (window as any).google) {
        setLoading(false);
        return;
      }

      isInitialized.current = true;
      setLoading(true);

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_GOOGLE_PLACE_API_KEY}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        setLoading(false);
      };
      script.onerror = () => {
        setLoading(false);
      };

      document.body.appendChild(script);
    };

    if (!isInitialized.current) {
      loadSdk();
    }
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
